export default __webpack_public_path__ + "static/media/MaerskLogo.0e865e73.png";